import React from "react";

interface ColorBlockIconAttribs {
    color: string;
    icon: (props: any) => JSX.Element;
    iconColor?: string | undefined;
    className?: string;
}

const ColorBlockIcon = ({color, icon, iconColor, className}: ColorBlockIconAttribs) => {
    const Icon = icon;
    const iconStyle = iconColor ? {borderColor: iconColor, color: iconColor, backgroundColor: 'white'} : {};
    return (
        <div className={'color-block-icon'} style={{backgroundColor: color}}>
            <Icon style={iconStyle} className={className ? className : "whiteCircleOutlineIcon "} />
        </div>
    )};

export default ColorBlockIcon;